export const environment = {
  production: false,
  urlBase: 'https://aplicacion-analitica-869579121266.us-central1.run.app',
  firebaseConfig: {
    apiKey: 'AIzaSyDK_QNAnIa_NuG8NerdBi3Hb99YdtQaIvo',
    authDomain: "novaventa-co.firebaseapp.com",
    projectId: "novaventa-co",
    storageBucket: "novaventa-co.firebasestorage.app",
    messagingSenderId: "1078407497421",
    appId: "1:1078407497421:web:6263fa8dcafb63b2d54b84",
    apiUrl: 'https://identitytoolkit.googleapis.com/v1'
  },
  KEY: '',
  genIA: {
    iaURL: 'https://gen-ai-back-869579121266.us-central1.run.app',
    apiKey: 'PROVATE_KEY_GEN_BAI'
  }
};
